<script lang="ts">
    import { _ } from "svelte-i18n";
    import Navbar from "../header/Navbar.svelte";
    import Footer from "../footer/Footer.svelte";
    import ModelCard from "./ModelCard.svelte";
    import { appManager } from "../AppManagerStore";
    import { ModelsManager } from "./ModelsManager";
    import { onMount } from "svelte";

    const manager = new ModelsManager({
        whitelist: [
            // {
            //     id: "6bf6a1d3-b974-4590-8549-451a31ef40d8",
            //     image: "img/posts/simulating-commutes/screenshot-sla-mechelen.png",
            //     tags: ["commute"],
            //     type: "dataset",
            // },
            {
                id: "eb380de7-f143-4799-9765-0d7a1d9c7717",
                image: "img/covers/cover-schools-netherlands.jpg",
                tags: ["school", "safety", "kids"],
                type: "simulation",
            },
            {
                id: "e5ae22d8-ca96-4361-a104-7e7fe22a43af",
                image: "img/models/velo_antwerp.png",
                type: "simulation",
            },
            {
                id: "d91f2a2d-3a20-492f-b751-42b0dbe14d03",
                image: "img/models/villo_brussels.png",
                type: "simulation",
            },
            {
                id: "6a31ebfe-c8d8-455c-988e-2676afddab84",
                image: "img/models/sevici.png",
                type: "simulation"
            },
            {
                id: "b5f02548-6463-455d-9a3f-631e910db097",
                image: "img/models/tfl_cycle_hire.png",
                type: "simulation",
            },
            {
                id: "e9f1a826-1dea-4a88-a1a7-280042f25867",
                image: "img/models/v_lille.png",
                type: "simulation",
            },
            {
                id: "8471d808-eaa3-4d04-9b7c-353c24b54bb4",
                image: "img/models/dublinbikes.png",
                type: "simulation",
            },
            {
                id: "8f34922a-d617-423e-9abc-6925d6533550",
                image: "img/models/velib.png",
                type: "simulation",
            },
            {
                id: "baec2096-cdbd-4763-aa21-30d0a9116b63",
                image: "img/models/helsinki.png",
                type: "simulation",
            },
            {
                id: "ac19cd25-6639-40ae-9291-6d53ef6ca4ac",
                image: "img/models/bicimad.png",
                type: "simulation",
            }
        ],
    });

    const modelsStore = manager.getModelsStore();

    onMount(async () => {
        await manager.InitializeAsync();
    });
</script>

<svelte:head>
    <title>ANYWAYS | {$_("models.pagetitle")}</title>
</svelte:head>

<Navbar background={"light"} isFluid={false} />

<section class="pt-4 pt-md-11 mb-8">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-12 col-md-5 order-md-2">
                <img
                    src="{$appManager.PublicUrl}img/illustrations/illustration-2.png"
                    class="img-fluid mb-6 mb-md-0"
                    alt="..." />
            </div>
            <div class="col-12 col-md-7 order-md-1">
                <h1 class="display-4">
                    {$_("models.banner.explore")} <br />
                    <span class="text-primary">{$_("models.banner.simulated")}</span>
                </h1>

                <p class="lead text-body-secondary mb-2">
                    {$_("models.banner.explain1")}
                </p>

                <p class="lead text-body-secondary mb-4">
                    {$_("models.banner.explain2")}
                </p>

                <a
                    href="{$appManager.PublicUrl}contact"
                    target="_blank"
                    class="btn btn-primary me-1 lift">
                    {$_("models.title.contact")}
                    <i class="fe fe-arrow-right ms-3" />
                </a>
                <a href="#explore" class="btn btn-primary-soft lift">
                    {$_("models.title.explore")}
                </a>
            </div>
        </div>
    </div>
</section>

<section class="my-4 my-md-7 py-5" id="explore">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h2 class="mb-0">
                    {$_("models.global.title")}
                    <i class="fe fe-globe text-primary"></i>
                </h2>
                <p class="mb-5 text-muted">
                    {$_("models.global.subtitle")}
                </p>
            </div>
        </div>
        <div class="row">
            {#each $modelsStore as model}
                {#if model.isGlobal}
                    <ModelCard info={model} />
                {/if}
            {/each}
        </div>
    </div>
</section>
<section class="pt-8 pt-md-11">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h2 class="mb-0">
                    {$_("models.local.title")}
                    <i class="fe fe-crosshair text-primary"></i>
                </h2>
                <p class="mb-5 text-muted">
                    {$_("models.local.subtitle")}
                </p>
            </div>
        </div>
        <div class="row">
            {#each $modelsStore as model}
                {#if !model.isGlobal}
                    <ModelCard info={model} size={"small"} />
                {/if}
            {/each}
        </div>
    </div>
</section>

<Footer bgClass="bg-white" />
